import { get, values } from "lodash-es";

export const getError = (error: any) => {
	const arrayOfErrors: string[][] = values(
		get(error, "response.data.errors", null),
	);
	let allErrors = "";

	if (arrayOfErrors.length) {
		allErrors = concatErrorMessagges(arrayOfErrors, allErrors);
	}

	return get(
		error,
		"response.data.result",
		get(
			error,
			"response.data.message",
			get(
				error,
				"internalError.message",
				get(
					error,
					"response.data.detail",
					get(error, "response.data.title", error.toString()) + " " + allErrors,
				),
			),
		),
	);
};

const concatErrorMessagges = (arrayOfErrors: string[][], string: string) => {
	arrayOfErrors.forEach((element: string[], index: number): void => {
		if (index !== 0) {
			string += ". ";
		}
		string += element.join("");
	});

	return string;
};

export const MESSAGE_API = {
	ERROR_MESSAGE: "There was an error to connect to server.",
	ERROR_EMPTY_SEARCH: "Empty rows",
};
export const MESSAGE_ERRORS = {
	ERROR_TITLE: "There was an error",
	ERROR_EMPTY_SEARCH: "Empty rows",
	ERROR_USER_API: "Error on fetching data",
	ERROR_USER_DEFAULT: "Unknow error",
	ERROR_SAVE_DATA: "Error on saving data",
	SUCCESS_SAVE_DATA: "Data was saved successfully",
};
export const USER_LABELS = {
	CHOOSE_OPTION: "Choose an option",
};

export class FetchError extends Error {
	status: number;
	internalError: string;

	constructor(message: string, status: number, internalError: string) {
		super(message);
		this.name = "FetchError";
		this.message = message || "Error al procesar la solicitud";
		this.status = status;
		this.internalError = internalError;
		this.stack = this.stack || "";
	}

	getMessageUser = () => {
		if (this.name === "FetchError") return MESSAGE_ERRORS.ERROR_USER_API;
		return MESSAGE_ERRORS.ERROR_USER_DEFAULT;
	};
}
